import React from "react";
import { useTranslation } from "react-i18next";

import { FacilityFilterConditionData } from "../../../../models/FacilityFilterConditionData";
import ModalFilterCondition from "../../../FacilityListComponents/ModalFilterCondition";

export interface IModalFilterConditionSectionProps {
  hasConditionFilter: boolean;
  setShownModalFilterCondition: (shown: boolean) => void;
  conditionFormData: FacilityFilterConditionData;
  onApplyFilterCondition: (
    conditionFormDataApply: FacilityFilterConditionData
  ) => void;
  onClickClearFilterCondition: () => void;
  getLabelsList: (dataArray: any[]) => string;
  shownModalFilterCondition: boolean;
  organizationId: string | null | undefined;
  me: any;
}

export const ModalFilterConditionSection = (
  props: IModalFilterConditionSectionProps
) => {
  const {
    hasConditionFilter,
    setShownModalFilterCondition,
    conditionFormData,
    onApplyFilterCondition,
    onClickClearFilterCondition,
    getLabelsList,
    shownModalFilterCondition,
    organizationId,
    me,
  } = props;

  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`analysisCollectionsPage.collectionChartArea.${key}`);

  return (
    <>
      <div
        className={`filter-wrap ${hasConditionFilter ? "filter-after" : ""}`}
      >
        <div className="filter-some-block">
          <button
            className="btn btn-filter"
            onClick={() => {
              setShownModalFilterCondition(true);
            }}
          >
            <i className="icons icon-filter"></i>
            <span className="txt">
              {!hasConditionFilter ? t("filter") : t("filtered")}
            </span>
          </button>
          <div className="after-info">
            <div className="label-area">
              {conditionFormData.healthIndex.length > 0 && (
                <div className="filter-label-list flex">
                  <div className="left-txt">{t("health_index")} :</div>
                  <div className="labels">
                    {getLabelsList(conditionFormData.healthIndex)}
                  </div>
                </div>
              )}
              {conditionFormData.municipalities.map((item, index) => (
                <React.Fragment key={index}>
                  {item.muniList.length > 0 && (
                    <div className="filter-label-list flex" key={index}>
                      <div className="left-txt">{item.name} :</div>
                      <div className="labels">
                        {getLabelsList(item.muniList)}
                      </div>
                    </div>
                  )}
                </React.Fragment>
              ))}
              {conditionFormData.categories.length > 0 && (
                <div className="filter-label-list flex">
                  <div className="left-txt">{t("categories")} :</div>
                  <div className="labels">
                    {getLabelsList(conditionFormData.categories)}
                  </div>
                </div>
              )}
              {conditionFormData.labels.length > 0 && (
                <div className="filter-label-list flex">
                  <div className="left-txt">{t("labels")} :</div>
                  <div className="labels">
                    {getLabelsList(conditionFormData.labels)}
                  </div>
                </div>
              )}
            </div>
            <a
              href="#javascript"
              className="btn btn-border"
              onClick={(event) => {
                onClickClearFilterCondition();
                event.preventDefault();
              }}
            >
              {t("clear_condition")}
            </a>
          </div>
        </div>
      </div>
      {shownModalFilterCondition && (
        <ModalFilterCondition
          organizationId={organizationId || ""}
          userId={me?.id}
          hideLodging={true}
          hideHealthIndex={true}
          hideProfBools={true}
          onClose={() => {
            setShownModalFilterCondition(false);
          }}
          conditionFormData={conditionFormData}
          onApply={(conditionFormDataApply: FacilityFilterConditionData) => {
            onApplyFilterCondition(conditionFormDataApply);
          }}
        />
      )}
    </>
  );
};
